import { z } from 'zod'

export const chatChannelFailedSchema = z.object({
  channelUrl: z.string().nullable().optional(),
  programUuid: z.string(),
  reason: z.string(),
})
